// extracted by mini-css-extract-plugin
export default {"container":"text_container__35wyF","input":"text_input__3QnT8"};